import React from 'react';
import ReactDOM from 'react-dom';
import AppRoute from './route';
import 'antd/dist/antd.css'
import './layouts/phone.scss';
ReactDOM.render(<AppRoute />, document.getElementById('root'));

